import { CSSProperties, FC, ReactNode } from 'react';
import { STROKE, TEXT } from '../../Helpers/colors';

interface ProgressBarProperties {
	backgroundColor?: string;
	color: string;
	height?: string;
	icon?: ReactNode;

	percentage: number;
	percentageText?: string;
	showPercentage?: boolean;
	style?: CSSProperties;
	textColor?: string;
	width?: string;
}

const CustomProgressBar: FC<ProgressBarProperties> = ({
	percentage,
	color,
	width = '104px',
	height = '4px',
	showPercentage = true,
	percentageText,
	icon,
	backgroundColor = STROKE.PRIMARY,
	textColor = TEXT.TERTIARY,
	style,
}) => {
	const displayPercentage = Math.min(Math.max(percentage, 0), 100);
	const progressHeight = `${parseInt(height) + 2}px`;

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				gap: '8px',
				...style,
			}}
		>
			<div
				style={{
					position: 'relative',
					width,
					height,
					backgroundColor,
					borderRadius: '100px',
					marginTop: '1px',
				}}
			>
				<div
					style={{
						position: 'absolute',
						top: '-1px',
						left: '0',
						height: progressHeight,
						width: `${displayPercentage}%`,
						backgroundColor: color,
						borderRadius: '100px',
						transition: 'width 0.3s ease',
					}}
				/>
			</div>
			{showPercentage && (
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '4px',
						color: textColor,
						fontSize: '14px',
						lineHeight: '20px',
						fontWeight: 'normal',
						whiteSpace: 'nowrap',
					}}
				>
					<span>{percentageText || `${percentage}%`}</span>
					{icon}
				</div>
			)}
		</div>
	);
};

export default CustomProgressBar;
